import React from 'react'

export default function PasswordHints({ hints }) {
  return (
        <>
            {hints.length > 0 ?
                <div className="mb-4 text-orange-300 text-sm">
                    Password must be:
                    <ul className='list-disc pl-[revert]'>
                        {hints.map((error, index) => (
                            <li key={index}>
                                {error}
                            </li>
                        ))}
                    </ul>
                </div>
            : ''}
        </>
    )
}

